module.exports = __webpack_public_path__ + "img/men4.55fc95fe.png";